<div class="modal-content">
    <div class="modal-header">
      <h2>Nueva Revisión</h2>
      <button
        type="button"
        class="btn-close"
        data-bs-dismiss="modal"
        aria-label="Close"
      ></button>
    </div>
    <form [formGroup]="form" (submit)="saveRevisionHandler()">
      <div class="modal-body">
        <div class="container-fluid">
          <div class="row">
            <div class="col-md-6 form-group">
              <label for="txtObjetivo">Objetivo:</label>
              <textarea
                id="txtObjetivo"
                name="txtObjetivo"
                cols="40"
                rows="2"
                formControlName="objetivo"
              ></textarea>
            </div>
            <div class="col-md-6 form-group">
              <label for="txtAlcance">Alcance:</label>
              <textarea
                id="txtAlcance"
                name="txtAlcance"
                cols="40"
                rows="2"
                formControlName="alcance"
              ></textarea>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12 form-group">
              <label for="ddlNegocio">Negocio:</label>
              <select
                class="form-control"
                id="ddlNegocio"
                name="ddlNegocio"
                (change)="changeNegocio($event)"
                formControlName="negocio"
              >
                <option value="0" disabled selected>Seleccione...</option>
                <option value="{{ ne.Negocio_Id }}" *ngFor="let ne of negocios">
                  {{ ne.Negocio_Descripcion }}
                </option>
              </select>
            </div>
          </div>
          <div class="row">
            <div class="col-md-6">
              <div class="form-group">
                <label for="ddlRegiones">Región:</label>
                <select
                  class="form-control"
                  id="ddlRegiones"
                  (change)="changeRegion($event)"
                  formControlName="region"
                >
                  <option value="0" disabled selected>Seleccione...</option>
                  <option
                    value="{{ region.IdRegion }}"
                    *ngFor="let region of regiones"
                  >
                    {{ region.Nombre }}
                  </option>
                </select>
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group">
                <label for="ddlEstaciones">{{ descriptionRegionSitio }}</label>
                <select
                  class="form-control"
                  id="ddlEstaciones"
                  formControlName="estacion"
                >
                  <option value="0" disabled selected>Seleccione...</option>
                  <option
                    value="{{ estacion.IdEstacion }}"
                    *ngFor="let estacion of estaciones"
                  >
                    {{ estacion.Nombre }}
                  </option>
                </select>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-6 ml-auto">
              <div class="form-group">
                <label for="fechaInicio">Fecha inicio planeada:</label>
                <input
                  type="date"
                  class="form-control"
                  id="fechaInicio"
                  name="fechaInicio"
                  formControlName="fechaInicio"
                />
              </div>
            </div>
            <div class="col-md-6 ml-auto">
              <div class="form-group">
                <label for="fechaFin">Fecha fin planeada:</label>
                <input
                  type="date"
                  class="form-control"
                  id="fechaFin"
                  name="fechaFin"
                  formControlName="fechaFin"
                />
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-4">
              <div class="form-group">
                <label for="ddlTipoRevisiones">Tipo de revisión:</label>
                <select
                  class="form-control"
                  id="ddlTipoRevisiones"
                  formControlName="tipoRevision"
                >
                  <option value="0" disabled selected>Seleccione...</option>
                  <option
                    value="{{ tipoRevision.IdTipoRevision }}"
                    *ngFor="let tipoRevision of tipoRevisiones"
                  >
                    {{ tipoRevision.Descripcion }}
                  </option>
                </select>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button
          type="submit"
          id="btnAgregarRevision"
          class="btn btn-primary primary"
          [disabled]="form.invalid"
        >
          agregar revisión
        </button>
      </div>
    </form>
  </div>
  